module.exports = __webpack_public_path__ + "img/cloth_g1_hat_03.af8e2105.svg";